const token = {
  colorPrimary: "#a224e9",
  colorSuccess: "#64a45a",
  colorBgMask: "rgba(255, 255, 255, 0.4)",
  borderRadius: 3,
}

export default token
